export default "__VITE_PUBLIC_ASSET__650e2630__"